import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=1a8e3cf7"
import script from "./AlbumDetail.vue?vue&type=script&lang=js"
export * from "./AlbumDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports